export const countryOptions = [
  { text: "United States", value: "US" },
  { text: "United States Territories", value: "UM" },
  { text: "Canada", value: "CN" },
];
